// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__J05pcn4Q","error":"Captcha_error__rAGe4hvV"};